import { StorageKey } from '@utilities/authConstants';

/**
 * Rotates the login-session id; call only when an interactive AscensionID login redirect completes.
 * Embedded apps use it to reset per-login UI state that sessionStorage would otherwise keep.
 */
export const startLoginSession = (): string => {
	const loginSessionId = window.crypto.randomUUID();
	window.sessionStorage.setItem(StorageKey.LOGIN_SESSION_ID, loginSessionId);
	return loginSessionId;
};

// Tabs authenticated by silent SSO never see a login redirect, so create an id on first use.
export const getLoginSessionId = (): string =>
	window.sessionStorage.getItem(StorageKey.LOGIN_SESSION_ID) || startLoginSession();
